import { Box, BoxProps } from "@chakra-ui/react";

export const SidebarIcon = (props: BoxProps) => {
  return (
    <Box {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.74953 22.2096C5.20931 22.2096 4.74781 22.0183 4.36503 21.6357C3.98244 21.253 3.79114 20.7915 3.79114 20.2512V5.75136C3.79114 5.21114 3.98244 4.74964 4.36503 4.36686C4.74781 3.98427 5.20931 3.79297 5.74953 3.79297H20.2494C20.7896 3.79297 21.2511 3.98427 21.6339 4.36686C22.0165 4.74964 22.2078 5.21114 22.2078 5.75136V20.2512C22.2078 20.7915 22.0165 21.253 21.6339 21.6357C21.2511 22.0183 20.7896 22.2096 20.2494 22.2096H5.74953ZM8.66614 20.5846V5.41797H5.74953C5.66612 5.41797 5.58974 5.45272 5.52041 5.52224C5.45089 5.59157 5.41614 5.66795 5.41614 5.75136V20.2512C5.41614 20.3347 5.45089 20.411 5.52041 20.4804C5.58974 20.5499 5.66612 20.5846 5.74953 20.5846H8.66614ZM10.2911 20.5846H20.2494C20.3328 20.5846 20.4092 20.5499 20.4785 20.4804C20.548 20.411 20.5828 20.3347 20.5828 20.2512V5.75136C20.5828 5.66795 20.548 5.59157 20.4785 5.52224C20.4092 5.45272 20.3328 5.41797 20.2494 5.41797H10.2911V20.5846Z"
          fill="#798692"
        />
      </svg>
    </Box>
  );
};
